import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import SearchDropdown from "../input/SearchDropdown";
import {
  getOtherRefSearchDropdown,
  getTemplateDropdown,
} from "../../api/keyvalue";
import { vehicleAssignmentSearch } from "../../api/jobApi";
import { useDispatch, useSelector } from "react-redux";
import { formGeneratorActions } from "../../store/form-generator/form-generator-slice";
import { useEffect, useState } from "react";
import { Loader } from "react-feather";

const componentTypes = {
  TEXT: 1,
  NUMBER: 2,
  DATE: 3,
  DATETIME: 4,
  DROPDOWN: 5,
  SEARCH_DROPDOWN: 6,
  UNDEFINED: -1,
};

const endpointToApi = {
  "/transportservice/keyvalues/dropdownsearch": getOtherRefSearchDropdown,
  "/transportservice/job/vehicleassignment/search": vehicleAssignmentSearch,
  "/transportservice/keyvalues/template-dropdown": getTemplateDropdown,
};

const FormField = ({
  field,
  sectionState,
  setSectionState,
  searchFieldReset,
  setSearchFieldReset,
}) => {
  const errors = useSelector((state) => state.formGenerator.errors);
  const dispatch = useDispatch();

  const error = errors[field.scfField];

  const [options, setOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (field.fetchLive) {
        setIsLoading(true);
        const { params, fetchUrl } = field.liveTemplateDropdownRequest;

        const api = endpointToApi[fetchUrl];
        const data = await api(params);

        setOptions(data);
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return (
      <Input
        required={field.scfMandatory}
        label={field.scfName}
        key={field.scfCode}
        value={"Loading..."}
      />
    );
  }

  let formComponent;
  switch (field.componentType) {
    case componentTypes.TEXT: {
      formComponent = (
        <Input
          required={field.scfMandatory}
          label={field.scfName}
          key={field.scfCode}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          value={sectionState[field.scfField]}
          onChange={(e) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: e.target.value,
            }))
          }
        />
      );
      break;
    }
    case componentTypes.NUMBER: {
      // TODO : TREAT AS NUMBER
      formComponent = (
        <Input
          required={field.scfMandatory}
          label={field.scfName}
          key={field.scfCode}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          value={sectionState[field.scfField]}
          onChange={(e) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: e.target.value,
            }))
          }
        />
      );
      break;
    }
    case componentTypes.DATE: {
      formComponent = (
        <Input
          required={field.scfMandatory}
          type="date"
          label={field.scfName}
          key={field.scfCode}
          value={sectionState[field.scfField]}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          onChange={(e) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: e.target.value,
            }))
          }
        />
      );
      break;
    }
    case componentTypes.DATETIME: {
      // TODO : TREAT AS DATE TIME
      formComponent = (
        <Input
          required={field.scfMandatory}
          type="date"
          label={field.scfName}
          key={field.scfCode}
          value={sectionState[field.scfField]}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          onChange={(e) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: e.target.value,
            }))
          }
        />
      );
      break;
    }
    case componentTypes.DROPDOWN: {
      formComponent = (
        <Dropdown
          required={field.scfMandatory}
          multiple={!!field.scfMultiple}
          label={field.scfName}
          placeholder={field.scfName}
          options={field.fetchLive ? options : field.options}
          key={field.scfCode}
          value={sectionState[field.scfField] ?? []}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          onChange={(e, data) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: data.value,
            }))
          }
        />
      );
      break;
    }
    case componentTypes.SEARCH_DROPDOWN: {
      let params = { ...field.params };

      for (const [param, valueField] of Object.entries(
        field.dependencyParams,
      )) {
        const value = sectionState[valueField];
        params[param] =
          Array.isArray(value) && value.length > 0 ? value.join(",") : value;
      }

      formComponent = field.scfMultiple ? (
        <SearchDropdown
          required={field.scfMandatory}
          key={field.scfCode}
          occupySpace={false}
          multiple={true}
          reset={searchFieldReset}
          setReset={setSearchFieldReset}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          multiValueRemoveHandler={(key) => {
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: prevState[field.scfField].filter(
                (item) => item !== parseInt(key),
              ),
            }));
          }}
          onResultSelect={(data) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: !prevState[field.scfField]
                ? [data]
                : [...prevState[field.scfField], data],
            }))
          }
          api={endpointToApi[field.component.cop_endpoint]}
          apiDependency={params}
          label={field.scfName}
        />
      ) : (
        <SearchDropdown
          required={field.scfMandatory}
          key={field.scfCode}
          reset={searchFieldReset}
          setReset={setSearchFieldReset}
          error={error}
          resetError={() => {
            dispatch(formGeneratorActions.removeError(field.scfField));
          }}
          clearable={true}
          onClear={() =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: null,
            }))
          }
          onResultSelect={(data) =>
            setSectionState((prevState) => ({
              ...prevState,
              [field.scfField]: data,
            }))
          }
          api={endpointToApi[field.component.cop_endpoint]}
          apiDependency={params}
          label={field.scfName}
        />
      );
      break;
    }
    default:
  }

  return formComponent;
};
export default FormField;
